import { isEmpty } from 'lodash';
import React from 'react';

import { FormMethod } from '@swf/core/enums';

import type {
  DepositContext,
  DepositResult,
  WorldPay3DS2Info
} from '../../../../../../types/Cashier';
import useRedirectContext from '../../useRedirectContext';
import Redirect from '../Redirect/Redirect';
import RedirectForm from '../RedirectForm/RedirectForm';

type Props = DepositContext & { depositResult: DepositResult; cmsHeaderAndGridLayout: boolean };

const RejectedX3dSecure2Redirect: React.FC<Props> = ({
  deposit,
  previousDeposit,
  depositResult,
  cmsHeaderAndGridLayout
}) => {
  const redirectContext = useRedirectContext();
  const { wc2Paycallback, transactionId, redirectUrl, resultInfo } = depositResult;

  if (wc2Paycallback) {
    return (
      <Redirect
        deposit={deposit}
        previousDeposit={previousDeposit}
        cmsHeaderAndGridLayout={cmsHeaderAndGridLayout}
        {...depositResult}
      />
    );
  }
  const resultInfoStatement = (resultInfo as WorldPay3DS2Info) || {};
  const { jwt, md, url } = resultInfoStatement;

  const worldPayRedirectUrl = {
    ...redirectUrl,
    method: FormMethod.Post,
    prms: {
      JWT: jwt,
      MD: md
    },
    url
  };

  return (
    <RedirectForm
      context={{
        ...redirectContext,
        transactionId: resultInfoStatement.transId ?? transactionId,
        ...(!isEmpty(md) ? { challenge3DS2MD: md } : {})
      }}
      {...(isEmpty(resultInfoStatement) ? redirectUrl : worldPayRedirectUrl)}
    />
  );
};

export default RejectedX3dSecure2Redirect;
